(function() {
  'use strict';

  const SELECTORS = {
    priceContainer: '.rbr-productNamePrice__price__container',
    productCard: '.rbr-stn__productDetail__container, .rbr-productNamePrice__container',
    priceEl: '.money',
    productLink: 'a[href*="/products/"]'
  };

  function getLocaleRoot() {
    const shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (shopifyRoot && shopifyRoot !== '/') return shopifyRoot.endsWith('/') ? shopifyRoot : shopifyRoot + '/';
    const pathMatch = window.location.pathname.match(/^(\/[a-z]{2}(?:-[a-z]{2})?\/)/i);
    if (pathMatch) return pathMatch[1];
    return '/';
  }

  function getActiveCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    const active = document.querySelector('#currencies .active[data-currency]');
    if (active) return active.getAttribute('data-currency');
    if (typeof window.Currency !== 'undefined' && window.Currency.currentCurrency) {
      return window.Currency.currentCurrency;
    }
    return '';
  }

  const priceCache = new Map();

  async function fetchCorrectPrice(handle) {
    // Key and fetch per active currency: a price cached/served for a previous
    // currency must never be reused, so the block always shows the selected
    // currency's price as soon as it appears (no reload needed).
    const currency = getActiveCurrency();
    const cacheKey = handle + '|' + currency;
    if (priceCache.has(cacheKey)) return priceCache.get(cacheKey);
    const root = getLocaleRoot();
    let url = `${root}products/${encodeURIComponent(handle)}?section_id=fbp-price-fix`;
    if (currency) url += `&currency=${encodeURIComponent(currency)}`;
    try {
      const res = await fetch(url, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const html = await res.text();
      const match = html.match(/<script type="application\/json" data-fbp-price>([\s\S]*?)<\/script>/);
      if (!match) throw new Error('No price data in response');
      const data = JSON.parse(match[1]);
      priceCache.set(cacheKey, data);
      return data;
    } catch (err) {
      return null;
    }
  }

  function extractHandle(card) {
    const link = card.querySelector(SELECTORS.productLink);
    if (!link) return null;
    const match = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return match ? match[1] : null;
  }

  async function fixPriceInCard(card) {
    const priceEl = card.querySelector(SELECTORS.priceEl);
    if (!priceEl || priceEl.hasAttribute('data-fbp-fixed')) return;
    const handle = extractHandle(card);
    if (!handle) return;
    const data = await fetchCorrectPrice(handle);
    if (!data || !data.price) return;
    const cleanPrice = String(data.price).replace(/<[^>]*>/g, '').trim();
    if (!cleanPrice) return;
    priceEl.textContent = cleanPrice;
    priceEl.setAttribute('data-fbp-fixed', 'true');
    priceEl.classList.remove('money');
    let restores = 0;
    const lockObs = new MutationObserver(function() {
      if (restores >= 30) { lockObs.disconnect(); return; }
      if (priceEl.textContent !== cleanPrice) {
        restores++;
        priceEl.textContent = cleanPrice;
      }
    });
    lockObs.observe(priceEl, { childList: true });
    setTimeout(function() { lockObs.disconnect(); }, 10000);
  }

  function scanAndFix() {
    const cards = document.querySelectorAll(SELECTORS.productCard);
    cards.forEach(fixPriceInCard);
    document.querySelectorAll(SELECTORS.priceContainer).forEach(container => {
      const card = container.closest(SELECTORS.productCard) || container.parentElement;
      if (card && !container.querySelector('[data-fbp-fixed]')) {
        fixPriceInCard(card);
      }
    });
  }

  const observer = new MutationObserver(() => {
    if (document.querySelector(SELECTORS.priceContainer)) scanAndFix();
  });

  function init() {
    scanAndFix();
    observer.observe(document.body, { childList: true, subtree: true });
    [500, 1500, 3000, 5000, 8000, 12000].forEach(ms => setTimeout(scanAndFix, ms));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
